import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavLogo,
  NavMenu,
  NavBtn,
  NavBtnLink,
  NavVersionTag,
  NavLogoContainer,
  FormH1
} from './NavbarHeaderElements';
import { Heading } from '@aws-amplify/ui-react';

const NavbarHeader = ({ toggle, heading = "" }) => {
  const [scrollNav, setScrollNav] = useState(false);
  const [visibleHeader, setVisibleHeader] = useState("");

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
      setVisibleHeader(heading);
    } else {
      setScrollNav(false);
      setVisibleHeader('');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogoContainer>
              <NavLogo onClick={toggleHome} to='/'>
                Ca$h Crew
              </NavLogo>
              <NavVersionTag onClick={toggleHome} to='/'>(Beta)</NavVersionTag>
            </NavLogoContainer>
            <FormH1 >{visibleHeader}</FormH1>
            {/* <MobileIcon onClick={toggle}>
              <FaBars />
            </MobileIcon>
            <NavMenu />
            <NavBtn>
              <NavBtnLink to='/signin'>Account</NavBtnLink>
            </NavBtn> */}
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default NavbarHeader;
